import '../../../styles/FiltersTable.css';
import { Table, Checkbox, Space } from 'antd';
import { remove } from 'lodash';
import React, { useState, useEffect } from 'react';

const FiltersTable = ({
  selectedData,
  setSelectedData,
  selectedsData,
  setSelectedsData,
  filterComponent,
  setFilterComponent,
  banderaTags,
  setBanderaTags,
  showLoadingData,
  setShowLoadingData,
}) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [columns, setColumns] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  useEffect(() => {
    const newSelectedRowKeys = selectedsData.map(item => item.value_filter);
    if (JSON.stringify(newSelectedRowKeys) !== JSON.stringify(selectedRowKeys)) {
      setSelectedRowKeys(newSelectedRowKeys);
    }
    setShowLoadingData(false);
  }, [selectedsData]);

  useEffect(() => {
    if (selectedData) {
      const newSelectedRowKeys = selectedsData.map(item => item.value_filter);
      setSelectedRowKeys(newSelectedRowKeys);
      const allSelected = selectedData.every(item => newSelectedRowKeys.includes(item.value_filter));
      setSelectAll(allSelected);
      setShowLoadingData(false);
    }
  }, [selectedData, selectedsData]);

  useEffect(() => {
    if (selectedData) {
      setSelectedRowKeys(filterComponent.map(item => selectedData.map(e => e.value_filter).includes(item.value_filter) ? item.value_filter : null))
      setSelectedsData(filterComponent)
      setShowLoadingData(false)
    }
  }, [filterComponent, selectedData, selectedsData, showLoadingData])

  useEffect(() => {
    if (selectedData) {
      setColumns([
        {
          title: 'Name',
          dataIndex: 'value_filter',
        },
      ]);
    }
  }, [selectedData]);

  const onSelectAllChange = (e) => {
    const isChecked = e.target.checked;
    setSelectAll(isChecked);
    if (isChecked) {
      const newSelectedsData = [...selectedsData, ...selectedData.filter(item => !selectedsData.some(selectedItem => selectedItem.value_filter === item.value_filter))];
      setSelectedRowKeys(newSelectedsData.map(item => item.value_filter));
      setSelectedsData(newSelectedsData);
      setFilterComponent(newSelectedsData);
    } else {
      const newSelectedsData = selectedsData.filter(item => !selectedData.some(dataItem => dataItem.value_filter === item.value_filter));
      setSelectedRowKeys(newSelectedsData.map(item => item.value_filter));
      setSelectedsData(newSelectedsData);
      setFilterComponent(newSelectedsData);
    }
  };

  const onSelectTable = (record, selected) => {
    if (!selected) {
      remove(selectedsData, { value_filter: record.value_filter });
      const newSelectedsData = [...selectedsData];
      setSelectedsData(newSelectedsData);
      setSelectedRowKeys(newSelectedsData.map(item => item.value_filter));
      setFilterComponent(newSelectedsData);
    } else {
      //setSelectedsData([...selectedsData, record])
      const newSelectedsData = [...selectedsData, record];
      setSelectedsData(newSelectedsData);
      setSelectedRowKeys(newSelectedsData.map(item => item.value_filter));
      setFilterComponent(newSelectedsData);
    }
  };

  return (
    <>
      <Space style={{ marginBottom: 10 }}>
        <Checkbox onChange={onSelectAllChange} checked={selectAll}>
          Seleccionar todo
        </Checkbox>
      </Space>
      {columns.length > 0 ?
        <Table
          className="tableComportamientos"
          rowSelection={{
            selectedRowKeys,
            onSelect: onSelectTable,
          }}
          columns={columns}
          loading={showLoadingData}
          dataSource={selectedData}
          pagination={{ pageSize: 1000 }}
          rowKey='value_filter'
          scroll={{ y: 150 }}
        />
        : 
        'Sin resultados...'
      }
    </>
  );
};

export default FiltersTable;